module.exports = __webpack_public_path__ + "images/color-fun-3-4706f8ad1a5f41773e817797d67e6ac6.jpg";